import Header from '../components/DSX/Header';

function NotFound() {
	return (
		<div className="not-found">
			<Header value="404 Page Not Found" />
			<h3>We are sorry but the page you are looking for does not exist.</h3>
		</div>
	);
}

export default NotFound;
